import React from 'react';

/** 枠だけ用意して中身は後続PRで実装する機能ページのプレースホルダ。 */
export default function AdminComingSoon({ children }) {
  return (
    <div className="rounded-2xl border border-dashed border-[#d4c4b0] bg-white p-8 text-center text-[#6b5540]">
      <p className="font-medium text-[#2d1810]">この機能は準備中です</p>
      <p className="mt-2 text-sm">今後のアップデートで追加されます。</p>
      {children && <div className="mt-4 text-sm">{children}</div>}
    </div>
  );
}
